// client/src/config.js
// Usa il protocollo e host corrente
export const API_BASE_URL = `${window.location.protocol}//${window.location.host}/api`;

export const WS_BASE_URL = `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}`;

export default API_BASE_URL;